import { ContractLineValidator } from '@/services/validation/ContractLineValidator';

import { ContractLineToCreate } from '../hooks/useCreateContractLine';

import { validationSchema } from './validationSchema';

export const validator = new ContractLineValidator<Partial<ContractLineToCreate>>(validationSchema);
